/* @flow */
import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AppLoader from '../AppLoader';
import customStyles from './LandmarkDetails.module.scss';
import List from '../SharedComponents/List/List';
import AssetListItem from './AssetInLandmarkListItem';
import { getRefreshChip } from '../../util/map_utils';
import { getUserToken, isPairedAsset, postData } from '../../helper-classes/utility-functions';
import CargoMenu from '../AssetList/CargoMenu';
import { getAssetsInLandmarkRequestURL, getAssetsInLandmarkRequestBody } from '../../containers/Landmark/LandmarkDetails/epics.landmarks';
import { getCargoMenuText } from '../../helper-classes/utility-react-functions';

export type Props = {
    assetLoader: boolean,
    assetInLandmark: Object,
    pageChanged: Function,
    refreshAssetListData: Function,
    showAssetRefeshChip: boolean,
    redirectTo: Function,
    landmarkId: String,
};
type State = {
    totalNumberOfPage: number,
    page: number,
    totalCount: number,
    data: Array<{ id: string, name: string }>,
    anchorEl: any,
    loaded: boolean,
    unLoaded: boolean,
}

class AssetInLandmark extends Component<Props, State> {
    currentPage: number;
    constructor(props) {
        super(props);
        this.state = this.getInitState();
        this.currentPage = 0;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.assetInLandmark && nextProps.assetInLandmark.data) {
            const response = nextProps.assetInLandmark;
            const { data } = nextProps.assetInLandmark;
            if (data && data.length > 0) {
                let newData;
                if (this.state.data && this.state.data.length > 0) {
                    newData = this.state.data;
                    let stateId = '';
                    if (newData.length > 0) {
                        stateId = newData[newData.length - 1].id;
                    }
                    if (data.length > 0
                    && stateId !== data[data.length - 1].id) {
                        data.forEach((d) => {
                            newData.push(d);
                        });
                        this.setState({
                            data: newData,
                            page: this.currentPage,
                        });
                        if (this.state.totalNumberOfPage <= 0) {
                            this.calculatedPageCount(response);
                        }
                    }
                } else if (this.props.assetLoader && !nextProps.assetLoader) {
                    this.setState({
                        data,
                        page: this.currentPage,
                    });
                    if (this.state.totalNumberOfPage <= 0) {
                        this.calculatedPageCount(response);
                    }
                }
            }
        }
    }

    getInitState = () => ({
        totalNumberOfPage: 0,
        page: 0,
        totalCount: 0,
        data: [],
        anchorEl: null,
        loaded: false,
        unLoaded: false,
    })

    calculatedPageCount = (res: any) => {
        if (res.total && res.total > 0) {
            const count = res.count || 10;
            const totalNumberOfPage = Math.ceil(res.total / count);
            this.setState({ totalNumberOfPage, totalCount: res.total });
        }
    };

    pageChanged = (page) => {
        this.currentPage = page;
        this.props.pageChanged({ currentPage: page });
    };

    menuHandleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    handleCheckBoxChange = (e, type) => {
        this.setState({
            [type]: e.target.checked,
        }, () => {
            this.refreshAssetListData(true);
        });
    }

    getHeader = () => {
        const { totalCount, data, loaded, unLoaded } = this.state;
        return (
            <React.Fragment>
                <div className={customStyles['assets-in-landmark']}>
                    <div className={customStyles.header}>
                        <Typography variant="h5" className={customStyles['main-header']} component="h3">
                            Assets in Landmark
                        </Typography>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <Typography className={customStyles['asset-sub-header']} paragraph component="p">
                                Showing {data.length} of {totalCount}
                            </Typography>
                            <div
                                className={customStyles['available-Assets']}
                                onClick={this.menuHandleClick}
                                onKeyDown={() => {}}
                                role="button"
                                tabIndex="0"
                                style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                }}
                            >
                                <Typography variant="h6" className={customStyles['available-assets-title']}>
                                    {getCargoMenuText(loaded, unLoaded)}
                                </Typography>
                                <span className={customStyles['available-assets-title']}>
                                    <ArrowDropDownIcon />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={customStyles['header-border']} />
            </React.Fragment>
        );
    };

    listItems = data => (
        <div
            onClick={() => {
                if (data && isPairedAsset(data)) {
                    this.props.redirectTo(`/home?assetId=${data.id}&back=true&zoom=true`, 'assetInLandmark');
                }
            }}
            role="link"
            tabIndex={0}
            onKeyDown={() => {}}
            key={data.id}
        >
            <AssetListItem
                asset={data}
                landmarkId={this.props.landmarkId}
            />
        </div>
    );

    getList = () => {
        const { assetLoader, landmarkId } = this.props;
        const { totalNumberOfPage, page, data } = this.state;
        let list = '';
        const isData = data && data.length > 0;
        if (isData) {
            list = (<List
                data={data}
                height={280}
                currentPage={page}
                totalNumberofPage={totalNumberOfPage}
                pagination={{ isPagination: true, pageChanged: this.pageChanged }}
                getListItem={this.listItems}
                showMessage={false}
                landmarkId={landmarkId}
            />);
        }
        return (
            <React.Fragment>
                {list}
                { assetLoader ? <div className={customStyles.detailLoader}><AppLoader /></div> : ''}
                {!isData && !assetLoader && landmarkId ? <div className={customStyles['no-assets-in-landmark']}>There are currently no assets in this landmark.</div> : ''}
            </React.Fragment>
        );
    }

    refreshAssetListData = (loadNewData) => {
        const { loaded, unLoaded } = this.state;
        if (loadNewData) {
            this.setState({ ...this.getInitState(), loaded, unLoaded });
            this.currentPage = 0;
        }
        let cargoLoadedQuery = '';
        if (loaded && unLoaded) {
            cargoLoadedQuery = 'eq:true,false';
        } else if (loaded) {
            cargoLoadedQuery = 'eq:true';
        } else if (unLoaded) {
            cargoLoadedQuery = 'eq:false';
        }
        this.props.refreshAssetListData({ refresh: loadNewData, cargoLoadedQuery });
    }

    getCargoAssetCount = (isLoaded, landmarkId) => {
        const reqData = getAssetsInLandmarkRequestBody({
            currentPage: 0,
            recordsPerPage: 10,
            id: landmarkId,
            cargoLoadedQuery: `eq:${isLoaded ? 'true' : 'false'}`,
        });
        const headers = {
            'X-Nspire-UserToken': getUserToken(),
            'Content-Type': 'application/json',
        };
        return postData(
            getAssetsInLandmarkRequestURL(landmarkId),
            JSON.stringify(reqData),
            headers,
        );
    }

    render() {
        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);

        return (
            <React.Fragment>
                {this.getHeader()}
                {this.props.showAssetRefeshChip
                    && getRefreshChip(this.refreshAssetListData)}
                {open &&
                    <CargoMenu
                        anchorEl={anchorEl}
                        open={open}
                        handleClose={this.handleClose}
                        handleCheckBoxChange={this.handleCheckBoxChange}
                        loaded={this.state.loaded}
                        unLoaded={this.state.unLoaded}
                        getCargoAssetCount={(isLoaded) =>
                            this.getCargoAssetCount(isLoaded, this.props.landmarkId)}
                    />
                }
                {this.getList()}
            </React.Fragment>
        );
    }
}

export default withStyles({}, { withTheme: true })(AssetInLandmark);
